define('presentation/settings/outboundCallingCampaigns/facades/outboundCallingCampaignsFacade',[
    'common/storage/commonState',
    'externalDependencies/clientWebSocket',
    'presentation/common/dateTimeValue',
    'presentation/settings/outboundCallingCampaigns/presentationObjects/outboundCallingCampaignPresentationObject',
    'settings/navigationConfiguration'
], function () {
    const DateTimeValueConstructor = require('presentation/common/dateTimeValue');
    const OutboundCallingCampaignPresentationObjectConstructor = require('presentation/settings/outboundCallingCampaigns/presentationObjects/outboundCallingCampaignPresentationObject');

    const clientWebSocket = require('externalDependencies/clientWebSocket');
    const outboundCallingCampaignSocket = clientWebSocket.forApplication("outboundCallingCampaign");

    const _navigationConfiguration = require('settings/navigationConfiguration');

    let _promiseFactory = null;

    const _buildOutboundCallingCampaignPresentationObject = (campaign) => {
        const outboundCallingCampaignPresentationObject = new OutboundCallingCampaignPresentationObjectConstructor();
        outboundCallingCampaignPresentationObject.outboundCallingCampaignId = campaign.outboundCallingCampaignId;
        outboundCallingCampaignPresentationObject.name = campaign.name;
        outboundCallingCampaignPresentationObject.campaignCode = campaign.campaignCode;
        outboundCallingCampaignPresentationObject.active = campaign.active;
        outboundCallingCampaignPresentationObject.genesysCampaignId = campaign.genesysCampaignId;
        outboundCallingCampaignPresentationObject.outboundCallerId = campaign.outboundCallerId;
        outboundCallingCampaignPresentationObject.liveReceptionistScriptId = campaign.liveReceptionistScriptId;
        outboundCallingCampaignPresentationObject.editOutboundCallingCampaignUrl =
            _navigationConfiguration.routesById.editOutboundCallingCampaign.baseUrl + campaign.outboundCallingCampaignId;
        outboundCallingCampaignPresentationObject.canActivate = (campaign.scriptStatus === 1);
        outboundCallingCampaignPresentationObject.createdDateTime = new DateTimeValueConstructor(campaign.createdDateTime);
        outboundCallingCampaignPresentationObject.updatedDateTime = new DateTimeValueConstructor(campaign.updatedDateTime);

        return outboundCallingCampaignPresentationObject;
    };

    const _getOutboundCallingCampaigns = () => {
        return _promiseFactory.defer((promise) => {
            outboundCallingCampaignSocket.send('getOutboundCallingCampaigns', { }, response => {
                const outboundCallingCampaignPresentationObjects = response.map(_buildOutboundCallingCampaignPresentationObject);
                promise.resolve(outboundCallingCampaignPresentationObjects);
            });
        });
    };

    const _deleteOutboundCallingCampaign = (outboundCallingCampaignId) => {
        return _promiseFactory.defer((promise) => {
            outboundCallingCampaignSocket.send('deleteOutboundCallingCampaign', { outboundCallingCampaignId }, response => {
                promise.resolve(response);
            });
        });
    };

    const _changeOutboundCallingCampaignActiveStatus = (outboundCallingCampaignId, makeActive) => {
        return _promiseFactory.defer((promise) => {
            const changeCampaignActiveStatusRequest = {
                outboundCallingCampaignId: outboundCallingCampaignId,
                makeActive: makeActive
            };
            outboundCallingCampaignSocket.send('changeOutboundCallingCampaignActiveStatus', changeCampaignActiveStatusRequest, response => {
                const outboundCallingCampaignPresentationObject = _buildOutboundCallingCampaignPresentationObject(response);
                promise.resolve(outboundCallingCampaignPresentationObject);
            });
        });
    };

    const _init = (promiseFactory) => {
        _promiseFactory = promiseFactory;
    };

    return function () {
        const self = this;
        self.init = _init;
        self.deleteOutboundCallingCampaign = _deleteOutboundCallingCampaign;
        self.getOutboundCallingCampaigns = _getOutboundCallingCampaigns;
        self.changeOutboundCallingCampaignActiveStatus = _changeOutboundCallingCampaignActiveStatus;
    };
});

